const ProductType = {
  RETAIL_PRODUCT: "P",
  SALON_PRODUCT: "L",
  SERVICE: "S",
  COUPON: "C",
  PACKAGE: "G",
};


export { ProductType };